import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css/navigation";
import "swiper/css";
import "./sliderVersion.scss";
import { FormattedMessage } from "react-intl";
import LabelLang from "component/LabelLang/label-lang";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant";
import { API_BASE_URL } from "configs/AppConfig";
import DataNotFound from "../DataNotFound/DataNotFound";

function SliderVersion() {
  const EvidenceAndClassification = useSWR({
    url: END_POINTS.EVIDENCE_CLASSIFICATIONS,
  });
  const versions =
    EvidenceAndClassification.error ||
    EvidenceAndClassification.isLoading ||
    EvidenceAndClassification.data === undefined ||
    EvidenceAndClassification.data === null
      ? []
      : EvidenceAndClassification.data.data;

  return (
    <div className="slider-chart">
      <div className="container">
        <div className="m__title">
          <h3>
            {" "}
            <FormattedMessage id="classifications" />{" "}
          </h3>
        </div>
        <Swiper
          modules={[Navigation]}
          navigation={{
            prevEl: ".prev",
            nextEl: ".next",
          }}
          spaceBetween={20}
          breakpoints={{
            0: {
              // width: 640,
              slidesPerView: 1,
            },
            // when window width is >= 640px
            640: {
              width: 640,
              slidesPerView: 1,
            },
            // when window width is >= 768px
            768: {
              width: 768,
              slidesPerView: 3,
            },
          }}
          slidesPerView={5}
        >
          {Object.keys(versions).length > 0 ? (
            versions.map(
              (
                {
                  pdfCover,
                  pdfUrl,
                  name,
                  evidenceAndClassificationTranslations,
                },
                i
              ) => (
                <SwiperSlide key={i}>
                  <a href={`${API_BASE_URL}/${pdfUrl}`} target="_blank">
                    <div className="card-vv">
                      <img
                        loading="lazy"
                        className="img-vv"
                        src={
                          pdfCover
                            ? `${API_BASE_URL}/${pdfCover}`
                            : process.env.PUBLIC_URL + "/image/book.png"
                        }
                        alt="item"
                      />
                      <h6>
                        <LabelLang
                          id="name"
                          defaultValue={name}
                          translations={evidenceAndClassificationTranslations}
                        />
                      </h6>
                    </div>
                  </a>
                </SwiperSlide>
              )
            )
          ) : (
            <DataNotFound />
          )}
          <br />
          {/* <div className="prev">
            <i className="fa fa-angle-left"></i>
          </div>
          <div className="next">
            <i className="fa fa-angle-right"></i>
          </div> */}
        </Swiper>
      </div>
    </div>
  );
}

export default SliderVersion;
